import type { JSX } from "react";
import { gaugeDash, clampPct } from "./geometry";
import { Term } from "../Term";

/**
 * Utilization gauge. Monochrome by default (Data Viz: color conveys meaning,
 * not decoration) — the arc only takes a semantic tone once it crosses the
 * warning / danger thresholds, so on a typical screen at most one ring is
 * colored.
 */
export function GaugeCircle({ percent, label, sublabel }: { percent: number; label: string; sublabel?: string }): JSX.Element {
  const r = 35, cx = 40, cy = 40, sw = 6;
  const circ = 2 * Math.PI * r;
  const { dash, gap } = gaugeDash(percent, circ);
  const p = clampPct(percent);
  const tone = p >= 90 ? "var(--color-error)" : p >= 75 ? "var(--color-warning)" : "var(--cc-viz-line)";
  return (
    <div className="cc-gauge">
      <svg viewBox="0 0 80 80" className="cc-gauge-svg" role="img" aria-label={`${label} ${Math.round(p)}%`}>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--border-color)" strokeWidth={sw} />
        <circle cx={cx} cy={cy} r={r} fill="none" stroke={tone} strokeWidth={sw} strokeLinecap="round"
          strokeDasharray={`${dash} ${gap}`} transform={`rotate(-90 ${cx} ${cy})`} className="cc-gauge-arc" />
        <text x={cx} y={cy + 4} textAnchor="middle" className="cc-gauge-pct">{Math.round(p)}%</text>
      </svg>
      <div className="cc-gauge-label"><Term>{label}</Term></div>
      {sublabel !== undefined && <div className="cc-gauge-sub">{sublabel}</div>}
    </div>
  );
}
